export class ListGitRepositoriesRequest {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "filters",
            "baseName": "filters",
            "type": "ListGitRepositoriesFilterConditions",
            "format": ""
        },
        {
            "name": "sorts",
            "baseName": "sorts",
            "type": "Array<SortGitRepositoryBy>",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return ListGitRepositoriesRequest.attributeTypeMap;
    }
    constructor() {
    }
}
